import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { publishQueryKeys } from '../queries/publishQueryKeys.js';
import { toast } from '../../store/alerts.js';

const useMutationPublishDisable = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ resourceId }) => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/publish",
        params: {
          resourceId
        }
      }, {
        method: "delete"
      });
    },
    onMutate: ({ resourceId }) => {
      queryClient.setQueryData(publishQueryKeys.resourcePublishDetails(resourceId), null);
    },
    onSuccess: () => {
      toast({
        content: "Item unpublished",
        id: "publish-disable-success"
      });
    },
    onError: (error, { resourceId }) => {
      toast({
        content: "Failed to update unpublish",
        id: "publish-disable-error"
      });
      queryClient.invalidateQueries({
        queryKey: publishQueryKeys.resourcePublishDetails(resourceId)
      });
    }
  });
  return mutation;
};

export { useMutationPublishDisable };
//# sourceMappingURL=useMutationPublishDisable.js.map
